export const FIELDS = {
  ORGANIZATION_URL: 'organization_url',
};

export const FORM_IDS = {
  ORGANIZATION_DETAILS: 'organization-details-form',
  INSTALL_APP: 'install-app-form',
};

export const STEP_IDS = {
  ORGANIZATION_DETAILS: 'organization-details',
  REVIEW_MANIFEST: 'review-manifest',
  INSTALL_APP: 'install-app',
  CHECK_CONNECTION: 'check-connection',
  RECOMMENDED_DISPLAY: 'recommended-display',
  ENABLE_QODO: 'enable-qodo',
};

export const ORGANIZATION_URL_PLACEHOLDER_SAAS =
  'https://github.com/yourorganization';
export const ORGANIZATION_URL_PLACEHOLDER_SELF_HOSTED =
  'https://github.yourcompany.com/yourorganization';

export const GITHUB_ERROR_CODES = {
  APP_NOT_FOUND: 'APP_NOT_FOUND',
  DUPLICATE_INSTALLATION: 'DUPLICATE_INSTALLATION',
  DATABASE_ERROR: 'DATABASE_ERROR',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
  INSTALLATION_CREDENTIALS_INVALID: 'INSTALLATION_CREDENTIALS_INVALID',
} as const;

export const QODO_LOGO_URL = '/images/github-installation/qodo-logo.png';
export const QODO_LOGO_FILENAME = 'qodo-logo.png';

export const ENABLE_QODO_TRANSLATION_KEY =
  'dialogs.github-installation.enable-qodo';

export const MT_PR_AGENT_WEBHOOK_HANDLER_FOR_GITHUB =
  'https://pro.github.pr-agent.codium.ai/api/v1/github_webhooks';

export const LOOPBACK_HOSTNAMES = new Set([
  'localhost',
  '127.0.0.1',
  '0.0.0.0',
  '[::1]',
  '::1',
]);
